import { render, staticRenderFns } from "./ResourceGrid.vue?vue&type=template&id=4b8c90de&"
import script from "./ResourceGrid.vue?vue&type=script&lang=ts&"
export * from "./ResourceGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports